import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';

@Component({
  selector: 'app-property-tax-form-editor',
  templateUrl: './pt-form-editor.component.html',
  styleUrls: ['./pt-form-editor.component.css']
})
export class PtFormEditorComponent implements OnInit {

  constructor(private route: ActivatedRoute, private propertyTaxService: PropertyTaxService, private translate: TranslateService, private toastr: ToastrService) { }
  template: string
  form: any
  forms = {
    propTaxForm : {title:'POPERTY-TAX-FORM'},
    buildingAttrForm : {title:'BUILDING-ATTRIBUTES-FORM'},
    lotAttrForm : {title:'LOT-ATTRIBUTES-FORM'},
  }


  async ngOnInit(): Promise<void> {
    this.template = this.route.snapshot.paramMap.get('template')
    if (this.template) {
      this.form = await this.propertyTaxService.getForm(this.template).toPromise()
      !this.form && (this.form = { key: this.template, name:this.translate.instant("PROPERTY-TAX."+this.forms[this.template].title) });
    }
  }

  async saveForm(form){
    this.form['blocks'] = form['blocks']
    await this.propertyTaxService.saveForm(this.form).toPromise()
    this.toastr.success('Success!', `Form saved`, {
      toastClass: "ngx-toastr border-red",
      timeOut: 3000
    });
  }

}
